var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var hexRegexReduced = /^#[a-fA-F0-9]{3}$/;
var hexRegex = /^#[a-fA-F0-9]{6}$/;
var hexToRgb = function (hexColor) {
    if (hexColor.match(hexRegex)) {
        return {
            red: parseInt("".concat(hexColor[1]).concat(hexColor[2]), 16),
            green: parseInt("".concat(hexColor[3]).concat(hexColor[4]), 16),
            blue: parseInt("".concat(hexColor[5]).concat(hexColor[6]), 16)
        };
    }
    if (hexColor.match(hexRegexReduced)) {
        return {
            red: parseInt("".concat(hexColor[1]).concat(hexColor[1]), 16),
            green: parseInt("".concat(hexColor[2]).concat(hexColor[2]), 16),
            blue: parseInt("".concat(hexColor[3]).concat(hexColor[3]), 16)
        };
    }
    return {
        red: 0,
        green: 0,
        blue: 0
    };
};
var colorToRgba = function (color) {
    return "rgba(".concat(color.red, ", ").concat(color.green, ", ").concat(color.blue, ", ").concat(color.alpha, ")");
};
var numberInRange = function (min, max, value) {
    return Math.max(min, Math.min(max, value));
};
export var opacity = function (amount, hexColor) {
    var parsedColor = hexToRgb(hexColor);
    var alpha = numberInRange(0, 1, amount);
    return colorToRgba(__assign(__assign({}, parsedColor), { alpha: alpha }));
};



//////////////////
// WEBPACK FOOTER
// ./src/helpers/Colors.ts
// module id = 198
// module chunks = 0